import { render, staticRenderFns } from "./TbExtensaoEditInformation.vue?vue&type=template&id=26a65243&"
import script from "./TbExtensaoEditInformation.vue?vue&type=script&lang=js&"
export * from "./TbExtensaoEditInformation.vue?vue&type=script&lang=js&"
import style0 from "./TbExtensaoEditInformation.vue?vue&type=style&index=0&id=26a65243&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports